<div *ngIf="(activatedRoute.queryParams | async).tab === tabId" class="pane">
  <ng-content></ng-content>
  <ng-container *ngTemplateOutlet="tabContent.first"></ng-container>
</div>
